import { BatchSingleUnderlyingWrapper } from 'components/common-form/builder/form/node/field/BatchSingleUnderlyingsField/BatchSingleUnderlyingField';
import { useMultipleApplyBatchUnderlyingsSearch } from 'components/common-form/builder/form/node/field/MultipleApply/hooks';
import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';

export function MultipleApplyBatchSingleUnderlyingField({ ...props }: ProductNodeBuilderProps) {
  const underlyingsSearch = useMultipleApplyBatchUnderlyingsSearch(props.tabId, props.node.id);
  return (
    <BlockOrientationFormGroup inputId={props.node.id} workspaceType="newBatch" contentPosition="bottom">
      <BatchSingleUnderlyingWrapper {...props} useOrientation={false} {...underlyingsSearch} />
    </BlockOrientationFormGroup>
  );
}
